export default __webpack_public_path__ + "static/media/organograma.ef217679.png";